export default __webpack_public_path__ + "static/media/menu.9dbc5a3a.svg";